import React, { useEffect, useState } from 'react'
import { Col, Row, Avatar , Badge } from 'antd'
import history from '../../../../routes/history';
import './timesheetcards.css'

const TimesheetListCards = (props) => {
    const gotoDetails=()=>{
        history.push({
            pathname:'/timesheet/details',
            state:{
                id:props._id,
                skill_listing:props.skill_listing.Title,
                job_title:props.gigs.Title,
            }
        })
    }
    return (
        <div className='timsheet-cards-column' onClick={gotoDetails}>
            <Row>
                <Col xs={5} lg={5}>
                    <Badge dot={true}>
                        <Avatar src="https://joeschmoe.io/api/v1/random" shape="circle" size="large" />
                    </Badge>
                </Col>
                <Col xs={17} lg={17}>
                    <div className='list-name'>{props?.users[0].name}</div>
                    <div className='list-titles'>{props?.skill_listing.Title}</div>
                    <div className='list-titles'>{props?.gigs.Title}</div>
                </Col>
            </Row>
        </div>
    )
}
export default TimesheetListCards;